import { render, staticRenderFns } from "./CollectionSlots.vue?vue&type=template&id=58f40044&scoped=true&"
import script from "./CollectionSlots.vue?vue&type=script&lang=ts&"
export * from "./CollectionSlots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f40044",
  null
  
)

export default component.exports